import { getUser } from 'Utils/storage';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import Moment from 'moment';
import ActionLoader from 'Components/ActionLoader/index';
import Sticky from 'Components/Sticky/index';
import Header from './components/Header';
import AuditLog from './components/AuditLog';
import { GET_AUDIT_LOG_DETAILS } from 'Constants/actionConstants';
import { useEffect, useState } from 'react';
import { isSapDPL } from 'Utils/index';

const Container = styled.div`
  padding: 20px;
  background: #F4F6FF;
  height: calc(100vh - 100px);
`;

const today = new Date();
today.setHours(23, 59, 59, 999);
const toEpoch = today.getTime();  // End of today

const oneMonthAgo = new Date();
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
oneMonthAgo.setHours(0, 0, 0, 0);
const fromEpoch = oneMonthAgo.getTime();  // Start of one month ago

const AuditDashboard = () => {
    const { loaderT1 } = useSelector(state => state.common);
    const dispatch = useDispatch();

    const [auditData, setAuditData] = useState([]);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [fromDate, setFromDate] = useState(fromEpoch);
    const [toDate, setToDate] = useState(toEpoch);
    const [search, setSearch] = useState('');
        

    useEffect(() => {
        getAuditDetails()
    },[debouncedSearch, fromDate, toDate])

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedSearch(search);
      }, 500); // debounce delay in milliseconds
    
      return () => {
        clearTimeout(handler);
      };
    }, [search]);

    const handleSearch = (search) => {
      setSearch(search);
    }

    const handleEditDateChange = ({ startDate, endDate }) => {
      const from = Moment(startDate).startOf('day').valueOf();     
      const to = Moment(endDate).endOf('day').valueOf();          

      setFromDate(from);
      setToDate(to);
    };

    const rfqId = localStorage.getItem('rfqId');
    const tripId = localStorage.getItem('tripId');

    const getAuditDetails = () => {
        const onSuccess = (data) => {
          setAuditData(data || []);
        }
        const params = {
          dashBoardType: 1,
          fromDate,
          toDate
        }
        if (debouncedSearch) {
          params.search = debouncedSearch;
        }
        if(isSapDPL()){
          params.dashBoardType = 2
          params.rfqId = rfqId
          params.tripId = tripId
        }
    
        dispatch({
          type: GET_AUDIT_LOG_DETAILS,
          params,
          onSuccess
        })
      }

    return (
    <Sticky>
    <Container>
      {!!loaderT1 && <ActionLoader fixed={true}/>}
      <Header title="Audit Dashboard" />
      
      <AuditLog 
        auditData={auditData}
        fromDate={fromDate}
        toDate={toDate}
        search={search}
        handleEditDateChange={handleEditDateChange}
        handleSearch={handleSearch}
      />
    </Container>
    </Sticky>
  );
}

export default AuditDashboard;
